module.exports = __webpack_public_path__ + "static/media/boy-large.1a536f05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Sex/boy-large.svg
// module id = 319
// module chunks = 0